// addvalue.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { SHOP_ID, Entrypoint } from '../resource/shopConstants.js';

import getOperationData from '../selector/getOperationData.js';

import fetchShopSections from '../action/fetchShopSections.js';
import setDefaultShopCurrency from '../action/setDefaultShopCurrency.js';
import openAddvalueModal from '../action/openAddvalueModal.js';
import cancelShopping from '../action/cancelShopping.js';

/**
 * Open the shop for a given entry point.
 * Opens the shop modal immediately (showing a loading state), then fetches the
 * section layout; the response `modalType` drives whether the shell renders the
 * quickpay or full-shop layout. On fetch failure the shell is closed.
 * @kind action
 * @param {object} [payload] - payload.
 * @param {string} [payload.entrypoint = 'addvalue'] - shop entry point.
 *   ['addvalue', 'chat', 'gift', ...]
 * @param {string} [payload.via = 'direct'] - start addvalue condition.
 *   ['direct', 'sufficient', 'insuficient']
 * @return {Promise} Action promise.
 */
const addvalue =
  ({
    entrypoint: entrypointValue = Entrypoint.ADDVALUE,
    via = 'direct',
  } = {}) =>
  async (dispatch, getState) => {
    let currency = getOperationData(getState(), ['shop'], 'currency');
    if (!currency) {
      await dispatch(setDefaultShopCurrency());
      currency = getOperationData(getState(), ['shop'], 'currency');
    }

    // Reset the previous result so the shell shows its loading state while the
    // new sections are fetched.
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['shop', SHOP_ID.addvalue],
        data: {
          entrypoint: entrypointValue,
          modalType: undefined,
          sections: undefined,
        },
      },
    });

    dispatch(openAddvalueModal({ via }));

    await dispatch(
      fetchShopSections({ entrypoint: entrypointValue, currency })
    );

    const modalType = getOperationData(
      getState(),
      ['shop', SHOP_ID.addvalue],
      'modalType'
    );

    return modalType
      ? dispatch({ type: '' })
      : dispatch(cancelShopping({ shopId: SHOP_ID.addvalue }));
  };

export default addvalue;
